// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3qD-n","icon":"SortAdornment_icon__7cVi8","up":"SortAdornment_up__3ocYT","down":"SortAdornment_down__26aPe","active":"SortAdornment_active__TKMbt"};